<script lang="ts" setup>
import { Link } from '@inertiajs/vue3'
import { isSameApp } from '@shared/url'

const { href } = defineProps<{
  href?: string
}>()

const attrs = useAttrs()

const tag = $computed(() => {
  if (attrs.download || attrs.target || (href && !isSameApp(href)) || String(href).startsWith('mailto:')) return 'a'
  if (!href) return 'button'
  return Link
})
</script>

<template>
  <component :is="tag" v-bind="$props">
    <slot/>
  </component>
</template>
